import {
  GET_VIEWMODEL_REQUEST,
  GET_VIEWMODEL_SUCCESS,
  GET_VIEWMODEL_ERROR,
  SET_FILTERED_LIST,
  RESET_FILTERED_LIST,
} from "../actionTypes";

export const initialState = {
  template: "",
  title: "",
  description: "",
  filteredList: [],
  isLoading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VIEWMODEL_REQUEST:
      const { title, description, logo, navigation } = state;
      return {
        title,
        description,
        logo,
        navigation,
        isLoading: true,
        error: null,
      };
    case GET_VIEWMODEL_SUCCESS:
      return {
        ...state,
        ...action.payload,
        filteredList: action.payload.contents,
        filteredAlphaTabs: action.payload.navigation.alphaTabs,
        isLoading: false,
      };
    case GET_VIEWMODEL_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case SET_FILTERED_LIST:
      return {
        ...state,
        filteredList: action.payload.filteredList,
        filteredAlphaTabs: action.payload.filteredAlphaTabs,
      };
    case RESET_FILTERED_LIST:
      return {
        ...state,
        filteredList: state.contents,
        filteredAlphaTabs: state.navigation.alphaTabs,
      };
    default:
      return state;
  }
};
